define('home/templates/mustVerifyEmail',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "Disqus.com requires you to\n<a href=\"#\" data-action=\"verify-email\">verify your email address</a> before posting\n";
},"useData":true})

});
